<template>
  <div id="app" :class="{valkiria: isAppScreen}">
    <socket ref="socket" :app="app" @onConnected="onSocketConnected"></socket>
    <NavigationLeftComponent v-if="loaded && logged && !navigationLeftRestricted && !sessionExpired" :app="app" />
    <navigation-side-app v-if="loaded && logged && isAppScreen && !sessionExpired" :app="app" />
    <SessionExpiredView v-if="sessionExpired" :app="app" />
    <router-view ref="router-view" v-if="loaded && !sessionExpired && (logged || unlogged.includes(this.$router.currentRoute.name))" :app="app" id="router-view" :class="{'left-navigation': logged && !navigationLeftRestricted, 'open': true, iphonex: app.config.style.iphonex}" />
    <UserLoginView v-if="loaded && !logged && !sessionExpired && !unlogged.includes(this.$router.currentRoute.name)" :app="app" />
    <LoadingView v-if="!loaded" />
    <div id="version">V {{ version }}</div>
  </div>
</template>

<script>
// Endpoints
import Endpoints from '@/router/endpoints.json'

// Locales
import localeES from '@/locale/es'

// Components
import NavigationLeftComponent from '@/components/navigation/navigation-left.component'

// Views
import LoadingView from '@/views/loading.view'
import UserLoginView from '@/views/user/login.view'
import SessionExpiredView from '@/views/app/session-expired.view'

// Dependencies
import WebFontLoader from 'webfontloader'

// Utils
import Socket from '@/utils/socket.util'

export default {
  name: 'app',
  components: {
    NavigationLeftComponent,
    LoadingView,
    UserLoginView,
    SessionExpiredView,
    Socket
  },
  data () {
    return {
      version: '1.2.84',
      loaded: false,
      sessionExpired: false,
      unlogged: [
        'speedtest',
        'user.password.reset',
        'signature',
        'biometric.register',
        'premium.payment'
      ],
      app: {
        strings: {},
        config: {
          language: 'es',
          target: 'production',
          style: {
            navigationLeft: true,
            iphonex: false
          }
        },
        socket: '',
        url: {
          api: '',
          nirvana: '',
          development: {
            api: 'http://localhost:3001',
            nirvana: 'http://localhost:3102'
            // api: 'http://192.168.86.23:3001'
          },
          production: {
            api: 'https://hermes.grupofacilauto.com',
            nirvana: 'https://nirvana.grupofacilauto.com/api'
          }
        },
        endpoints: Endpoints,
        user: {
          id: 0,
          business: {
            id: 0,
            name: '',
            config: {
              presentation_mode: 0
            }
          },
          company: {
            id: 0,
            name: '',
            code_letter: '',
            code_number: ''
          },
          center: {
            id: 0,
            code: ''
          },
          center_id: 0,
          name: '',
          email: '',
          role: 'user',
          avatar: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABuwAAAbsBOuzj4gAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAxSSURBVHic1VtrdFTVFf72uffOTGaSEGICAUIgEEUjUqQISq2gaMUQkLgETXi4usSqa5VKfMBqtVLtKhWLiLp8oAWVh2mhiEsF5GGhvmpRBF/UByrvZ0Iek0xm5t57dn9MMslM7mQmmTss+/2a2eecffb55px99tnnDDEzziZKbij/E5hKmuuOX7Jjxw7jrHZuAXHWe2QaD2C4Ozc356z3bYGzT8CPDP9XBJSUVUyZWDZ9uJ061YQ6vqHiKjAWSqYH3nptzfakeiR+G0xO3+nT1V1pVlJWMQ/AIgZvAjAxKRsizEnACV5XVlFOwCsATALds3HDmifsMiARTLyh/A5mehZAI4S4ZtP61R/apTshAgCgZMr0WSB+HoCTwMs3bqiabZcRnWHy5IocQ8FJAAEGl2zeULXTTv0JEwAAE6eUj2aiDQD6mMwFW16rOmynMVYgIrqurPz3IPH2pvWr37ddf1fjgMmTK3J0TRZuXv+3jxKpP3PL0j5CNwebUPIEIRvMkY6XoUOIIwYbB53pjQdeHLfA3yWDkkSXCUgEt77+aIZP0l2syzLVqY0gQYk2DRDoNQlece7uhu0LFiyQthsXBdsJuPGVh69VNcfzAAocqobBvfrBkCYON1TD5NjjcakODMzMhVf341jjGTDzZwqj4qVJlV/aamAUbCNg1tbFnmBtcAmEuI0AmnDuSJRfNA4OJbTT+owAVn+xE+8e2RfRThUKbhwyBiWDfgqi0EypafbihU+34svqQ34C3buydO7TthhpAVsImP7qI4OkpO3MXAgApUNGY8awKy3rPrNnE/599Ovw99nDrsHYgqEd6klmPPR+Fb6vOwkAc1eVVqZk6006EqSHHhKGIV9uHbxHc+GmoVeEy03TRHuSpxePQ6tHGNCjV8TgDdNsM4wI5cVjW78umfHGktJkbbVC0gTcdL46l0hc3vp9UHYeNKEAAHRdx613VuLu+Q+GSejhdKO3JwsAMKRn37CeU6erUT7rdixe+kxYVpSVB4UEAAgiqpr55tIRydobjaQImLbu0SEQ4o+d1WGEpnMikCzRyZJMB3jjzNcfL+qalZ2jw1lgQtn0UQrJEWSKrw1VfPXW+lXHYzVWiFcwk7u97IfaEzCkCVUo0DQNy59ZAkVRwg7OG2zGyaY6AMC3tW2qe+XmoOrlZXBoWlj2fd3J6J0jDwKfzNj4+Jw1EytXcojfpNDBCZaUVXwG4KJ2ogYm7BaqUbFx7doTrcKK9YsulJK/sFI65YLLcPPQsVZFWLZ3C95rtxPcMXwCfpZ/QYd6zIyHP/g79tfG5H8/gVeAlE8MNg46DSUcQDWlccPaayvPxGrYHh1mAIFmScjrBWgIA+cBOI8YRTA1Z1TNKbF+gD37PkeB6caooSOgKiF/4DMCqNr3TsTgAWDF59vhDTbj2sKLw7OksdmHnXs/RN2ZWiB2DFXEoIVgCQUChtpmi1MHZr75+CEAuxnY5ZT608snz/NaKUloGxx5++3ax8uW6e1lFa8uekuafG103bFGb8wIDIYQBI/bg2+ydazS9icUCJ2XmYc7GwYjvcEAGDDAuD/tExwTvrg2xsFBSfzLNRPv3hFd0O04oPwfj3zKjGHR8p7swLTgQAxABnwu4C3tGD5VEpqNAICJej5GGjlwQmCfUocqxw8wk1/qAMAAP7yq9O4/tBd2m4Cb1z1yAkDvzupoac7OipMHA8EjddDyMkFa24bGuoR+ogGO/KzoJcTEdPXKSXP/2Sro9jZIjLS49qU442xUN8G79VsEvquJkAe+q4F367cwqpuim5AUvHzaumfSWwWpzQnK1BKg5riRMb4IzsHZEXLn4GxkjC+CmuPu0IYYA11pgblhHak0kJk7ceI2gAiOgT07ijXFUh62CxjT+jmlM4Blyo/z3cUlrR9SS4D5oyUgZ/qmxwYASSwBpvh7EyM0C0ik1tUED9XBv+8UzLpmKFlpcBX3gqMgK04rpSeAg90mgIAjDPSIV0+aEkoKCfD/9xSaPjjY1l9TEPrRenjGDIDrgl5x23fbMmbsTqheCpeBbAzCt8s6Me3bdRiyMRhXR/fjAAhLAkx/EIF6bzgGYGbIdokOOxE8WAs2rAlmQyJ4sDZmWyFDe3T3CdCEZVqcFAGhquGDDQBIPUSA7vNDGvaRYdY2d7s8oNFhIAkCnD2b9gCoj5YLTYXmiQwSmRnSMGAEdJi6fU8CyNW5C+uk/PvW43K3CXhx3AI/ge9JtL40JNKy0m09H6g5nm6VEyg8e5Nyz1VTf7ucwFtjlZu6ATMY+sWZGaZury9wDOgJNdd6kGquB44BMaJBxsbWj8nvTw7nbGI0WBWZ/gAMf9tNlzRNW30ACKGYP4oENdeDjPFFsZIpW1dOmrsqrMKOE1v5uj9PBtNLTIignDmUtYu+GlOdjg6ypCAZxukmGGd8ULPdIUKs9dezog5dfd2cI60C226GZr66sI9h0usMGhmvLhGgOLSUR4hROEKMGSsnVf6rvdA2CwImC4AKASBelMwMGAHd3uXQaYdYrRp0UfTgAZuOwwRQOZRXJHBOqL/I6UdChEYdBWmYADOElpAZXgDHErSnnhl7SdBuk7BrTcncvTHr2nM3uOgK0+QO7AKh9a86HUn3AQCQOHfV5Mr99igLwZYlIJmnxiojsm+ds8CNtilrgT0ZIRLjAeuY3PA3o7m6CZrHDWePzOS6Aa4B8MiERb++UBFGf8/AM9vWTl2blCOxhwApCyzFhoHGo6GbnUB9A4LeRqT37dP9LZC5cOJf7lwrBKYyCE0HztmOECndRtI+YNaGxb2ChnHSqszw++E7EVmkupzI6N8PQrXmXlNUnJOZhSxPOhShQBEKiICAHoQv4Oc977wTyZ5L67FpzpOWgVgiSGoGXL/8gSs0h7pcdbmslbtc0Nxp0H1tpzLDH0D9gUPIGlQYMRN6pmeiIDcPPdzpESfJ9jClSXvaCxibN895ygs82e0xdJmAK3c+pPZvzPhFc413tqZp14M7d6QZ+X3RePwkgt7GsEzqBoJeL5w9MkFEKOzVF/1z8+L2rRttJ0kCXgqynMtW+2sXECZg1tbFHvKL8wDFNAQ1qzB90B1+U/h7C0UMBqOIgfPzKfN6BnqzoLa9nRH7ElMIZOT3he9UNZpr2q7IVJcTTk1Dcf9ByHSnx2gciRYCDhDzrzbOe25b94YcCRUApq17PM3hVr4ggYGAhECLT9eCIIhQXBc1QCEI0mzJ+oBBsRhgBojg7pUDLd2DoLcRjox0qC4XLiwoQkZax8uLWJBSNpnUNHTLfSs7XPl0FyoAqGnSQyz6daUhKQJoyfdRyyCtwJLRGgpo7jRo7lCyZFBefpcGDwASfGrLvfYNHmgJhF4pvaeagZsI+CrRhu0PMtzJFZjV5YjHlYb8c+JnbKMRNIK2TPv2CI9idWnlhlWllcUETAbwbryGiqPtKYuUMtYEsCSgb3Zulw01pYTf1B/tcsM4iBkHzNr0xGiW8j4AZYgRMgcamsInOkVTQapiqUtxaBBKm4rLi4dDEdZ1Y+Fk/Zk37//JlEldapQA4gZC0zc9NoBYjCNgFDGNZvAwABoQSnkFvS2vN4igaiqgdOSKhIDqDM0YIQR+Xnxxl4ys9zUda0Rj4YLiqfET/V1ElyPB32x+ynnG0C8WhFEMGu6v8+az5GwiyoagnkJRssiCBNWhgRQBp6bh0iEdHpZYgplR01j/UaAmc8yCceNS8g8z2x9LT1u3TnEoP1zSVFP7hiM9Pad1WRCFUmGeNDdGFhV3qiOgB3Hk6BEml3LZwktn/sdWA6OQkufyAHD1g7e8zcxXCU2F5k6D4nJCUVTk9O/33vmFRQVEpEgpA5JlU23NmaF6IEB11dU4dfQYfN7Qgy5Kc+Zt/90LlucMu5CyBxIM4QdMSN1AoN4L1IcG1XD81At/Lb1rZfu6Vz94Sz0zdzgra7oR9xlOskgZAUIhv5QCSOCRBAPtnBuBFAESAlLhlCcNU0aA5nY1tj6kZFNCSgmWDGkRGChOrVmQACkUEWApaowsi41IGQEEbm71LqQIKC07AxM6eHPVoVm+hNQp9W9sUpeYZ1j+w0tItkpqWtWtCdQHY99v24SUERBk+TqAQJR428Z5z30cXZcl1nbUQEt2LHgx5f8gSxkB2+Yvq4fgEQSsA3AazEtJKLdZ1d08/9ktEFQC4CMwfQNgvuozl6bKtvb4Hy+w4XHIMIrvAAAAAElFTkSuQmCC'
        },
        business: [],
        companies: [],
        centers: [],
        teachers: [],
        vehicles: [],
        students: [],
        token: '',
        methods: {
          logout: this.logout,
          back: this.back,
          loadUserData: this.loadUserData
        },
        biometric: {
          detector: '',
          landmarks: '',
          recognition: ''
        },
        navigationLeft: (state) => {
          this.app.config.style.navigationLeft = state
        }
      }
    }
  },
  computed: {
    // Screens opened from the mobile app (/app/*) use the Valkiria look.
    isAppScreen () {
      return this.$route.path.indexOf('/app/') === 0
    },
    logged () {
      return this.app.token !== ''
    },
    navigationLeftRestricted () {
      let restricted = false

      restricted = this.app.user.business.config.presentation_mode === 1

      if (restricted === false) {
        restricted = !this.app.config.style.navigationLeft
      }

      return restricted
    }
  },
  watch: {
    // The app's WebView can be reused for another user: a different token in
    // the URL means another session, so nothing of the previous user may stay.
    '$route.query.token' (token) {
      this.switchToken(token)
    },
    '$route.params.token' (token) {
      this.switchToken(token)
    },
    // SweetAlert dialogs live on <body>, outside #app.
    isAppScreen: {
      immediate: true,
      handler (value) {
        document.body.classList.toggle('valkiria-body', value)
      }
    }
  },
  created () {
    // Safari on iOS only applies :active once the page listens to touches.
    document.addEventListener('touchstart', () => {}, {passive: true})

    this.emptyUserData = JSON.stringify({
      user: this.app.user,
      business: this.app.business,
      companies: this.app.companies,
      centers: this.app.centers,
      teachers: this.app.teachers,
      vehicles: this.app.vehicles,
      students: this.app.students
    })

    WebFontLoader.load({
      google: {"families":["Montserrat:300,400,500,600,700"]},
      active: function() {
        sessionStorage.fonts = true;
      }
    })

    document.addEventListener('message', (event) => {
      let message = JSON.parse(event.data)
      if (message.action === 'loaded') {
        console.log('Loaded receiver')
      } else if (message.action === 'biometric-detector') {
        console.log('biometric-detector processing...')
        this.app.biometric.landmarks = this.base64ToFloat32Array(window.biometric.detector)
        console.log('biometric-detector processed!')
      } else if (message.action === 'biometric-landmarks') {
        console.log('biometric-landmarks processing...')
        this.app.biometric.landmarks = this.base64ToFloat32Array(window.biometric.landmarks)
        console.log('biometric-landmarks processed!')
      } else if (message.action === 'biometric-recognition') {
        console.log('biometric-recognition processing...')
        this.app.biometric.recognition = new Float32Array(window.biometric.recognition)
        console.log('biometric-recognition processed!')
      }
    }, false);
  },
  mounted () {
    console.log('Starting app...')
    this.init()

    setInterval(() => {
    }, 1000)
  },
  methods: {
    init () {
      this.app.strings = localeES
      this.app.config.language = 'es'

      this.app.url.api = this.app.url[this.app.config.target].api
      // Local runs only: VUE_APP_API_URL (set when building or serving) points
      // the web to a local hermes-api instead of production.
      if (process.env.VUE_APP_API_URL) {
        this.app.url.api = process.env.VUE_APP_API_URL
      }
      this.app.url.nirvana = this.app.url[this.app.config.target].nirvana
      if (process.env.VUE_APP_NIRVANA_API_URL) {
        this.app.url.nirvana = process.env.VUE_APP_NIRVANA_API_URL
      }

      let origin = this.$route.query.origin
      if (origin !== 'browser' && origin !== 'app') {
        origin = 'browser'
      }
      let success = this.checkBrowserCompatibility(origin)

      if (success) {
        let token = this.$route.params.token
        if (token !== undefined && token !== null && token !== '') {
          this.updateToken(token)
        } else {
          token = this.$route.query.token
          if (token !== undefined && token !== null && token !== '') {
            this.updateToken(token)
          }
        }
        this.loadUserData()
      }

      let navigationLeft = this.$route.query.navigationLeft
      if (navigationLeft !== undefined && navigationLeft !== null && navigationLeft !== '') {
        if (navigationLeft === 'false') {
          this.app.config.style.navigationLeft = false
        }
      }

      let iphonex = this.$route.query.iphonex
      if (iphonex !== undefined && iphonex !== null && iphonex !== '') {
        if (iphonex === 'true') {
          this.app.config.style.iphonex = true
        }
      }

      if (this.$router.currentRoute.name === 'signature') {
        this.app.config.style.navigationLeft = false
      }

      if (this.$route.query.origin === 'app' && window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          action: 'console',
          data: {
            log: 'hermes-web-loaded'
          }
        }))
      }
    },
    checkBrowserCompatibility (origin) {
      if (origin === 'app') {
        return true
      }
      if (this.$router.currentRoute.name === 'speedtest') {
        return true
      }
      if (!this.$browserDetect.isChrome && this.$router.currentRoute.name !== 'signature') {
        this.$swal({
          title: this.app.strings.app.compatibility.title,
          html: this.app.strings.app.compatibility.content,
          icon: 'error',
          confirmButtonText: this.app.strings.common.download
        }).then((result) => {
          if(result.value) {
            window.open('https://www.google.com/chrome/','_blank')
          }
        })
        return false
      }
      return true
    },
    updateToken (token) {
      localStorage['hermes-token'] = token
      this.app.token = token
    },
    // Changes the session when the URL brings another token: forgets the
    // previous user (memory and cache), unmounts the screen and loads the new
    // user before showing anything again.
    switchToken (token) {
      if (token === undefined || token === null || token === '' || token === this.app.token) {
        return
      }
      this.loaded = false
      let empty = JSON.parse(this.emptyUserData)
      this.app.user = empty.user
      this.app.business = empty.business
      this.app.companies = empty.companies
      this.app.centers = empty.centers
      this.app.teachers = empty.teachers
      this.app.vehicles = empty.vehicles
      this.app.students = empty.students
      localStorage.removeItem('app-user')
      localStorage.removeItem('app-business')
      localStorage.removeItem('app-companies')
      localStorage.removeItem('app-centers')
      localStorage.removeItem('app-user-token')
      if (this.$refs.socket) {
        this.$refs.socket.disconnect()
      }
      this.updateToken(token)
      this.loadUserData()
    },
    loadUserData () {
      this.app.token = localStorage['hermes-token']

      if (this.app.token === null || this.app.token === undefined) {
        this.app.token = ''
      }

      if (this.app.token !== '') {
        this.$http.get(
          this.app.url.api + this.app.endpoints.user.data,
          {
            headers: {
              Authorization: 'Token ' + this.app.token
            }
          }
        ).then(response => {
          if (response.status === 200) {
            if (response.body.success === true) {
              this.app.user = response.body.data.user
              localStorage['app-user'] = JSON.stringify(this.app.user)

              this.app.business = response.body.data.business
              localStorage['app-business'] = JSON.stringify(this.app.business)

              this.app.companies = response.body.data.companies
              localStorage['app-companies'] = JSON.stringify(this.app.companies)

              this.app.centers = response.body.data.centers
              localStorage['app-centers'] = JSON.stringify(this.app.centers)

              // The offline copy is only valid for this session.
              localStorage['app-user-token'] = this.app.token

              this.userDataLoaded()
            } else {
              if (response.body.error.code === 'S100') {
                this.logout()
              } else {
                let error = response.body.error.code
                this.showError(this.app.strings, 'request', error, () => {
                  this.loadUserData()
                })
              }
            }
          } else {
            this.showError(this.app.strings, 'request-status-' + response.status, 'status-' + response.status, () => {
              this.loadUserData()
            })
          }
        }, () => {
          if (this.$route.query.origin !== 'app' || localStorage['app-user-token'] !== this.app.token) {
            this.showError(this.app.strings, 'request', 'status-network: Connection unreachable', () => {
              this.loadUserData()
            })
          } else {
            this.app.user = JSON.parse(localStorage['app-user'])
            this.app.business = JSON.parse(localStorage['app-business'])
            this.app.companies = JSON.parse(localStorage['app-companies'])
            this.app.centers = JSON.parse(localStorage['app-centers'])

            this.userDataLoaded()
          }
        })
      } else {
        this.loaded = true
      }
    },
    userDataLoaded () {
      let excluded = [
        'tax.list'
      ]
      if (this.app.user.business.config.presentation_mode === 1 && !this.$router.currentRoute.name.includes('presentation') && !this.unlogged.includes(this.$router.currentRoute.name) && !excluded.includes(this.$router.currentRoute.name)) {
        this.$router.push({name: 'presentation.dashboard'})
      }
      if (this.$refs['router-view'] !== undefined) {
        if (this.$refs['router-view'].appUpdated !== undefined) {
          this.$refs['router-view'].appUpdated()
        }
      }

      if (!this.$refs.socket.connected) {
        this.$refs.socket.connect(this.app.token)
      }

      this.loaded = true
    },
    // A student of the app: a known student, or one of the screens only a
    // student opens (his own profile, booking, bag).
    isStudentSession () {
      if (this.app.user.role === 'student') {
        return true
      }
      try {
        if (JSON.parse(localStorage['app-user'] || '{}').role === 'student') {
          return true
        }
      } catch (e) {
        // A broken copy says nothing.
      }
      let path = this.$route.path
      return path === '/app/student/profile' || path.indexOf('/app/student/practice/') === 0
    },
    logout () {
      // A student has no login here (his token comes from the Facilauto app):
      // a dead session only leaves the way back to Facilauto.
      if (this.isAppScreen && this.isStudentSession()) {
        this.sessionExpired = true
        this.loaded = true
        return
      }
      this.loaded = false
      // POST: the API has no GET /user/logout, so the GET it used to send
      // closed nothing on the server and Valkiria logged the teacher back in.
      this.$http.post(
        this.app.url.api + this.app.endpoints.user.logout,
        {},
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          localStorage.clear()
          setTimeout(() => {
            if (this.$route.query.origin === 'app' && window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                action: 'logout',
                data: {}
              }))
            } else {
              let params = {}
              for (let key in this.$route.query) {
                let value = this.$route.query[key]
                if (key !== 'token') {
                  params[key] = value
                }
              }
              params = new URLSearchParams(params).toString()
              let url = window.location;
              let baseUrl = url .protocol + "//" + url.host + "/" + url.pathname.split('/')[1]
              url = baseUrl + '#/?' + params
              window.location.replace(url)
              window.location.reload()
            }
          }, 1000)
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status, () => {
            this.logout()
          })
        }
      }, () => {
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable', () => {
          this.logout()
        })
      })
    },
    back () {
      if (this.$route.query.origin === 'app' && window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          action: 'back',
          data: {}
        }))
      } else {
        window.location.replace('https://alumno.examentrafico.com')
      }
    },
    onSocketConnected (socket) {
      this.app.socket = socket
      if (this.$refs['router-view'] !== undefined) {
        if (this.$refs['router-view'].socketConnected !== undefined) {
          this.$refs['router-view'].socketConnected()
        }
      }
    },
    onSocketDisconnected () {
      setTimeout(() => {
        this.loadUserData()
      }, 5000)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue2-timepicker/dist/VueTimepicker.css"></style>
<style src="vue-slider-component/theme/antd.css"></style>
<style lang="scss">
@import "@/assets/styles/variables.scss";

@import '@/assets/plugins/sweetalert2/dist/sweetalert2.min.scss';

$default-color: $color-background-dark;
$primary-color: $color-info;

@import 'vue2-datepicker/scss/index.scss';

@import "@/assets/styles/app.scss";
@import "@/assets/styles/components.scss";
@import "@/assets/styles/common.scss";
@import "@/assets/styles/animation.scss";
@import "@/assets/styles/valkiria-app.scss";

#router-view {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

#router-view.left-navigation {
  padding-left: 120px;
}

#router-view.left-navigation.open {
  padding-left: 270px !important;
}

#router-view.navigation-top-app.iphonex {
  padding-top: 80px !important;
}

#version {
  position: fixed;
  bottom: 10px;
  right: 10px;
  color: #333333;
  font-size: 12px;
  z-index: 20000;
  background-color: rgba(255,255,255,0.25);
  padding: 3px;
}
</style>
